import { httpClient } from 'Shared/network';
import type {
  GetPointLogListPointFilterTypeEnum,
  GetPointLogListResponse,
  PointCategoryEnum,
} from 'viewup-api/v2';

export interface GetEarnedHistoryReq {
  category?: PointCategoryEnum;
  endDate: number;
  limit: number;
  page: number;
  pointFilterType?: GetPointLogListPointFilterTypeEnum;
  startDate: number;
}

export const getEarnedHistory = async ({
  category,
  endDate,
  limit,
  page,
  pointFilterType,
  startDate,
}: GetEarnedHistoryReq): Promise<GetPointLogListResponse> => {
  const { data } = await httpClient.get<GetPointLogListResponse>('/v2/point/logs/list', {
    params: {
      endDate,
      limit,
      page,
      startDate,
      ...(category && { category }),
      ...(pointFilterType && { pointFilterType }),
    },
  });

  return data;
};
